/**
 * @module component/lib/TextInput
 */

import PropTypes from 'prop-types';
import React from 'react';

import { createBEM } from '../../../lib/utils/css';

import './TextInput.scss';

class TextInput extends React.Component {
  static propTypes = {
    type: PropTypes.string,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    touched: PropTypes.bool.isRequired,
    error: PropTypes.node,
  };

  static defaultProps = { type: 'text' };

  renderErrorMessage = hasError => {
    if (hasError) {
      return <div className='TextInput__errorMessage'>{this.props.error}</div>;
    }
  };

  render() {
    const { touched, error } = this.props;
    const hasError = touched && error;

    const classNames = createBEM('TextInput', {
      error: hasError,
    });

    return (
      <div className={classNames}>
        <input className='TextInput__input' {...this.props} />
        {this.renderErrorMessage(hasError)}
      </div>
    );
  }
}

export default TextInput;
